import React from "react";
import Authentication from "../template/Authentication";

export default () => <Authentication contentType={"login"} />;
